module.exports = __webpack_public_path__ + "img/caoxue.a9d25de1.png";